import { CurrentUsageData, RolloverData, UsageData } from 'src/types/usage';
import { isBetweenDates } from './dateUtil';

export const calculateRolloverData = (data: CurrentUsageData): RolloverData => {
  const totalPagesApplicable =
    data.printPlanPageAllowance +
    data.printPlanRolloverPageAllowance +
    data.printPlanOveragePageBlocks;

  const totalPagesPrinted =
    data.printPlanPageAllowancePrinted +
    data.printPlanRolloverPageAllowancePrinted +
    data.printPlanOveragePagesPrinted;

  return {
    totalPagesApplicable,
    totalPagesPrinted
  };
};

export const getCurrentCycle = (
  data: UsageData[]
): CurrentUsageData | undefined => {
  const items = data.map((period) => period.items).flat();

  return items.find((item) =>
    isBetweenDates(
      new Date(item.billingStartDate),
      new Date(item.billingEndDate)
    )
  );
};
